export enum DocumentId {
  SignedOffer = '101',
  SepaWarranty = '103',
  Offer = 'F9092F2C-8573-4632-9713-4A8E0A4F80B2',
  MortgageConditions = 'AFF6C876-DC41-49D0-8A8C-61E3D3EE5925',
  AdviceReport = 'D9420CE7-5706-421C-8EA3-EECE058F713A',
  LoanAgreement = '28C38989-1BA6-415F-84D1-C11B80B966C4',
  SignedLoanAgreement = '1245'
}
